'use client';
import Textra from 'react-textra';

const TextraFeatures = ({ data }: { data: string[] }) => {
  return (
    <div className="relative group mx-auto flex max-w-fit items-stretch justify-between overflow-hidden whitespace-nowrap rounded-full bg-muted border px-4 py-1.5 transition-all duration-200 text-sm mb-8">
      <Textra
        effect="topDown"
        data={data}
        className="text-center text-sm text-foreground font-normal tracking-wide"
      />
    </div>
  );
};

export default TextraFeatures;
